<template>
  <v-dialog
    v-model="localDialog"
    width="50%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <base-card
      :title="isEntryMode ? 'Add Manufacture' : 'Update Manufacture'"
      :v-card-text-class="'pa-4'"
    >
      <v-form @submit.prevent="submit" ref="ManufactureSetup">
        <v-row>
          <v-col lg="6" md="6" cols="12">
            <v-text-field
              density="compact"
              variant="outlined"
              bg-color="grey-lighten-4"
              v-model="name.value.value"
              :error-messages="name.errorMessage.value"
              clearable
            >
              <template #label>
                Name <span class="text-red-accent-4">*</span>
              </template>
            </v-text-field>

            <v-text-field
              label="Mobile"
              density="compact"
              variant="outlined"
              bg-color="grey-lighten-4"
              v-model="mobile.value.value"
              :error-messages="mobile.errorMessage.value"
              clearable
            ></v-text-field>
            <v-checkbox
              label="Active"
              v-model="status.value.value"
              :error-messages="status.errorMessage.value"
              density="compact"
              variant="outlined"
              hide-details
              single-line
              color="primary"
              value="1"
            ></v-checkbox>
          </v-col>

          <v-col lg="6" md="6" cols="12">
            <v-textarea
              density="compact"
              variant="outlined"
              bg-color="grey-lighten-4"
              v-model="address.value.value"
              :error-messages="address.errorMessage.value"
              clearable
              auto-grow
              rows="1"
            >
              <template #label>
                Address <span class="text-red-accent-4">*</span>
              </template>
            </v-textarea>

            <v-text-field
              label="Remarks (Optional)"
              density="compact"
              variant="outlined"
              bg-color="grey-lighten-4"
              v-model="remarks.value.value"
              :error-messages="remarks.errorMessage.value"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-card-actions>
          <v-layout class="justify-end">
            <v-btn
              class="bg-red"
              variant="flat"
              type="reset"
              @click="closeDialog"
              >Close</v-btn
            >
            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
              {{ isEntryMode ? "Save" : "Update" }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-form>
    </base-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl } from "@/store/api";
import baseCard from "@/components/utils/baseCard.vue";

export default {
  name: "ManufactureSetup",
  components: {
    baseCard
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        name: "",
        remarks: "",
        mobile: "",
        address: "",
        status: "1",
        manufacture_id: null,
      }),
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      selectedImage: null,
      errorMessages: "",
      preview: "/src/assets/no_preview.jpeg",
      loading: false,
      isEntryMode: true,
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.name.setValue(newData.name || "", false);
        this.mobile.setValue(newData.mobile || "", false);
        this.address.setValue(newData.address || "", false);
        this.remarks.setValue(newData.remarks || "", false);
        this.status.setValue(String(newData.status) || "1", false);
        this.manufacture_id.setValue(newData.id || "", false);
        this.preview = newData.logo
          ? fileServerUrl + newData.logo
          : "/src/assets/no_preview.png";
      },
    },
  },
  created() {},
  methods: {
    previewImage: function (event) {
      this.selectedImage = event.target.files[0];
      const input = event.target;
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      } else {
        this.preview = "/src/assets/no_preview.jpeg";
      }
    },
    clearImage() {
      this.preview = "/src/assets/no_preview.jpeg";
    },
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        name: yup.string().min(1).max(50).required().trim().label("Name"),
        mobile: yup.string().min(7).max(15).nullable().label("Mobile"),
        address: yup.string().min(5).max(150).trim().label("Address"),
        remarks: yup.string().max(250).nullable().trim().label("Remarks"),
      }),
    });

    const name = useField("name");
    const mobile = useField("mobile");
    const address = useField("address");
    const remarks = useField("remarks");
    const status = useField("status");
    const manufacture_id = useField("manufacture_id");
    const errorMessages = ref("");
    const loading = ref("");
    const selectedImage = ref(null);
    const store = useStore();

    const submit = handleSubmit((values) => {
      store
        .dispatch("saveUpdateManufacture", values)
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          toast.success(response.data.message);
          loading.value = true;
          store
            .dispatch("getManufactureList")
            .then((data) => {
              loading.value = false;
            })
            .catch((error) => {
              loading.value = false;
              toast.error(error.response.data.message);
            });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      remarks,
      name,
      mobile,
      address,
      status,
      errorMessages,
      selectedImage,
      manufacture_id,
      resetForm,
      loading,
    };
  },
  mounted() {},
};
</script>
